export default{
    medicinalActionDescription: "توضیحات دارویی",
    surgeryActionType: "نوع عمل جراحی",
    surgeryActionDescription: "توضیحات عمل جراحی",
    iCSIType: " نوع iCSI",
    iCSIDescription: " توضیحات iCSI",
    iUIType: "نوع iUI",
    iUIDescription: "توضیحات iUI",
    surgeryAction: "عمل جراحی",
    iCSI: "iCSI",
    iUI: "iUI",
}